import * as Sentry from '@sentry/react'
import {useEffect} from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom'

Sentry.init({
  dsn: 'https://64dfdea228784af9931c32cbea04939a@sentry.io/1760670',
  enabled: process.env.NODE_ENV === 'production' && !('Cypress' in window),
  release: process.env.REACT_APP_VERSION,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    })
  ],
  tracesSampleRate: 1.0
})
